import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  FormControlLabel,
} from "@material-ui/core";
import React, { useState } from "react";
import { blockArtist } from "../../../../sdk/artists";
import { rudderTrack } from "../../../../utils/rudderstack/init";

interface ArtistBlockDialogProps extends Omit<DialogProps, "open"> {
  artistId: string;
  artistName: string;
  blocked?: boolean;
  setBlocked?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ArtistBlockDialog: React.FC<ArtistBlockDialogProps> = ({
  artistId,
  artistName,
  blocked,
  setBlocked,
  ...props
}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [takedown, setTakedown] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const onClose = (forceClose = false) => {
    if (loading && !forceClose) {
      return;
    }
    setTakedown(false);
    setConfirm(false);
    setShow(false);
    setLoading(false);
  };

  const onBlock = () => {
    setLoading(true);
    blockArtist(artistId, takedown)
      .then(() => {
        rudderTrack("Artist Blocked", {
          artist_id: artistId,
          artist_name: artistName,
          blocked,
        });
        if (setBlocked) setBlocked(true);
        onClose(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <React.Fragment>
      <Button
        color="secondary"
        variant="contained"
        onClick={() => setShow(true)}
        disabled={blocked}
      >
        {blocked ? "Blocked" : "Block"}
      </Button>
      <Dialog
        {...props}
        open={show}
        onClose={() => onClose()}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Block Artist</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to block all users associated to {artistName}
            {takedown ? " and takedown all their catalog?" : "?"}.
          </DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                checked={confirm}
                onChange={(ev) => setConfirm(ev.target.checked)}
                name="confirm"
              />
            }
            label="Block this artist"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={takedown}
                onChange={(ev) => setTakedown(ev.target.checked)}
                name="takedown"
              />
            }
            label="Takedown their catalog"
          />
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={() => onClose()} color="primary">
            Cancel
          </Button>
          <Button
            disabled={!confirm || loading}
            onClick={onBlock}
            color="primary"
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              `Block${takedown ? " and takedown" : ""}`
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
